"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DarkSurveyOptions = _interopRequireDefault(require("./DarkSurveyOptions.style"));

var _DarkRadio = _interopRequireDefault(require("../DarkRadio"));

var DarkSurveyOptions =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DarkSurveyOptions, _React$Component);

  function DarkSurveyOptions() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DarkSurveyOptions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DarkSurveyOptions)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (index) {
      return function () {
        _this.props.callBack(index);
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderButtons", function () {
      return _this.props.options.map(function (item, index) {
        return _react.default.createElement(_DarkRadio.default, {
          disabled: _this.props.isDisabled,
          checked: _this.props.selectedOption === index,
          onChange: _this.onChange(index),
          className: (0, _classnames.default)(_DarkSurveyOptions.default.radioButton(_this.props.breakpoint), 'radio'),
          label: item,
          key: item
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(DarkSurveyOptions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          maxWidth = _this$props.maxWidth,
          style = _this$props.style,
          className = _this$props.className,
          breakpoint = _this$props.breakpoint;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_DarkSurveyOptions.default.main(breakpoint), className),
        style: (0, _objectSpread2.default)({
          maxWidth: maxWidth
        }, style)
      }, this.renderButtons());
    }
  }]);
  return DarkSurveyOptions;
}(_react.default.Component);

DarkSurveyOptions.propTypes = {
  options: _propTypes.default.array.isRequired,
  callBack: _propTypes.default.func,
  maxWidth: _propTypes.default.string,
  selectedOption: _propTypes.default.number,
  className: _propTypes.default.string,
  breakpoint: _propTypes.default.string
};
DarkSurveyOptions.defaultProps = {
  maxWidth: '526px',
  callBack: function callBack() {
    return null;
  },
  selectedOption: -1,
  className: '',
  breakpoint: '767px'
};
var _default = DarkSurveyOptions;
exports.default = _default;